import apis from '@/api'
import { ref } from 'vue'
// import bus from '@/utils/eventBus.js'
import store from '@/store'
export default function useFavorite() {
  const data = ref([{
    name: '',
    id: '',
    children: []
  }])
  // 查询收藏夹
  const queryFavorite = () => {
    apis.queryFavorite().then(res => {
      if(res.success){
        data.value = res.data
        store.commit('setFavData', res.data)
      }
    })
  }
  // 修改收藏夹
  const updateFavorite = data => {
    return apis.updateFavorite(data).then(() => {
      queryFavorite()
      return Promise.resolve()
    }).catch(() => Promise.reject())
  }
  // 新建收藏夹
  const addFavorite = data => {
    return apis.addFavorite(data).then(() => {
      queryFavorite()
      return Promise.resolve()
    }).catch(() => Promise.reject())
  }
  // 删除收藏夹
  const delFavorite = id => {
    return apis.delFavorite(id).then(() => {
      queryFavorite()
      return Promise.resolve()
    }).catch(() => Promise.reject())
  }
  // 收藏
  const doFavorite = json => {
    return apis.doFavorite(json).then(() => {
    }).catch(() => Promise.reject())
  }
  // 取消收藏
  const unFavorite = id => {
    return apis.unFavorite(id).then(() => {
    }).catch(() => Promise.reject())
  }
  return {
    data,
    queryFavorite,
    addFavorite,
    updateFavorite,
    delFavorite,
    doFavorite,
    unFavorite
  }
}
